import React from 'react'
import styled from 'styled-components'
import { isStaff } from '../../utils/helpers'

const LogoutLi = styled.li`
  padding: 5px 5px;
`

const MenuHeader = (props) => {
  const { isDropdownOn, handleProfileMenu, handleLogoutClick, username, handleInsightsClick, user } = props
  return (
    <li className='nav-header'>
      <div className={isDropdownOn ? 'open dropdown profile-element' : 'dropdown profile-element'}>
        <span className='fa fa-user-circle fa-3x' />
        <div data-toggle='dropdown' className='dropdown-toggle'>
          <span className='clear'>
            <span className='text-muted text-xs block cursor-pointer' onClick={() => handleProfileMenu()}>
              <span>
                <span>{username || (user ? user.email : '')}</span>{' '}
                <span>
                  <b className='caret' />
                </span>
              </span>
            </span>
          </span>
        </div>
        <ul className='dropdown-menu animated fadeInRight m-t-xs'>
          {isStaff(user) && (
            <LogoutLi>
              <span className='cursor-pointer' onClick={handleInsightsClick}>
                Insights
              </span>
            </LogoutLi>
          )}
          <LogoutLi>
            <span className='cursor-pointer' onClick={handleProfileMenu}>
              Profile
            </span>
          </LogoutLi>
          <LogoutLi>
            <span className='cursor-pointer' onClick={handleLogoutClick}>
              Log out
            </span>
          </LogoutLi>
        </ul>
      </div>
      <div className='logo-element'>Netki</div>
    </li>
  )
}

export default MenuHeader
